module.exports = __webpack_public_path__ + "static/media/cscc-6.e59b7f0e.jpg";